import React from 'react';

import { PulseIcon, PulseIconVariant } from 'src/components/icons/Pulse';
import { Apollo } from 'src/gql/generated';

interface StatusDotProps {
  status: Apollo.RowStatus;
}

const getVariantFromStatus = (status: Apollo.RowStatus): PulseIconVariant => {
  switch (status) {
    case Apollo.RowStatus.AiError:
    case Apollo.RowStatus.OcrError:
      return PulseIconVariant.Error;
    case Apollo.RowStatus.AiNotRun:
      return PulseIconVariant.WarnAmber;
    case Apollo.RowStatus.AiRunning:
      return PulseIconVariant.LoadingPrimary;
    case Apollo.RowStatus.AnswerStale:
      return PulseIconVariant.WarnYellow;
    case Apollo.RowStatus.OcrRunning:
      return PulseIconVariant.LoadingSecondary;
  }
};

export const StatusDot: React.FC<StatusDotProps> = ({ status }) => {
  const variant = getVariantFromStatus(status);
  return <PulseIcon animate={false} variant={variant} />;
};
